import { createMutation, invalidateQueries } from '@amzn/gsce-shared-react-lib';
import {
  CreateAuditCommand,
  type CreateAuditCommandInput,
} from '@amzn/gbsa-helios-typescript-client';
import { apiHeliosClient } from '../../../shared/data';
import { schedulePostMutationRefresh } from '../../../shared/hooks';
import { AuditQueryKeys } from './keys';

/**
 * v2 mutation hook for creating a new audit (POST /audits).
 * Wraps `CreateAuditCommand` via the shared `createMutation` helper.
 * Invalidates audit list queries on success so downstream infinite
 * queries refetch the updated list.
 *
 * Not retried — audit creation is not idempotent (duplicates would
 * confuse auditors); callers must surface the error and let the
 * user retry explicitly.
 */
export const useCreateAuditMutation = createMutation(
  (input: CreateAuditCommandInput) => apiHeliosClient.send(new CreateAuditCommand(input)),
  {
    onSuccess: (queryClient) => {
      void invalidateQueries(queryClient, [AuditQueryKeys.lists]);
      // ES eventual consistency: the list endpoint reads from ES which
      // may not have indexed the new audit yet. Schedule follow-up
      // invalidations so the list auto-refreshes once ES catches up.
      schedulePostMutationRefresh(queryClient, {
        queryKeys: [AuditQueryKeys.lists],
      });
    },
  },
);
